import { getCurrentUserSession } from 'providers/auth'
import { withoutUndefined } from 'utils/helpers'

export const authorizedGet = async ({
  endpoint,
  params,
}: {
  endpoint: string
  params?: { [key: string]: string | undefined }
}) => {
  try {
    const search = new URLSearchParams(withoutUndefined(params))
    const url = new URL(endpoint, process.env.REACT_APP_HELP_API)
    url.search = search.toString()

    const { session } = await getCurrentUserSession()
    if (!session) {
      throw Error('Current user session not found')
    }
    const idToken = session.getIdToken().getJwtToken()
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        Authorization: `${idToken}`,
      },
    })
    if (response.ok) {
      return response
    } else {
      const { error } = await response.json()
      throw Error(error)
    }
  } catch (e: any) {
    if (e.message === 'Failed to fetch')
      throw Error(
        'Please check your Internet connection and load the page again'
      )
    else throw e
  }
}
